// extracted by mini-css-extract-plugin
module.exports = {"label":"_93444fe79c--label--ZJs9L","icon":"_93444fe79c--icon--gFV9a","title":"_93444fe79c--title--LeqmQ","clickable":"_93444fe79c--clickable--jctkV"};